import {CommonBuildConfigurationInput as BuildConfigurationInput} from '../commonConfiguration.types'

import {IsConfirmedConfiguration} from './types'

export const buildIsConfirmedConfiguration = ({
  inputProps: {confirmationPinRequired}
}: BuildConfigurationInput): IsConfirmedConfiguration => {
  return {
    isConfirmed: {
      enabled: true,
      confirmationPinRequired
    }
  }
}
